module.exports = __webpack_public_path__ + "static/media/unsplash_YI_9SivVt_s.df058d8b.jpg";